import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {
    checkPermissionMasterParentStartingTree, getDocumentLabel,
    getGreekCurrencyFormat,
    isEmpty
} from "../../../../../_helpers/commonFunctions";
import {Badge, Button, Col, Modal, Row, Spinner} from "react-bootstrap";
import {LuPackageCheck, LuPackageSearch} from "react-icons/lu";
import axios from "axios";
import {
    setNewFixedAssetRecordAutomatedData
} from "../../../../../_reducers/DataPanel/FixedAssets/fixedAssetsSlice";
import {toast} from "react-toastify";
import NewFixedAssetRecord from "../new-fixed-asset-record";
import {validateFixedAssetRecord} from "../../../../../_helpers/validator";
import {postFixedAssetRecord} from "../../../../../_apis/api";
import Input from "../../../../common/Input";
import {openFixedAssetLocal} from "../../../../../_helpers/tabOpeners";

export const FixedAssetSalesAction = ({rowData, permissionsData}) => {
    // permissionsData gets passed through for performance purposes
    const dispatch = useDispatch();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);
    const ACTIVE_MAIN_TAB = useSelector((state) => state.ACTIVE_MAIN_TAB);
    const SALES = useSelector((state) => state.SALES);
    const FIXED_ASSETS = useSelector((state) => state.FIXED_ASSETS);
    const tabKey = TABS_DATA[ACTIVE_MAIN_TAB].key;

    const [show, setShow] = useState(false);
    const [loadingAssets, setLoadingAssets] = useState(false);
    const [loadingCorellation, setLoadingCorrelation] = useState(false);
    const [assets, setAssets] = useState([]);
    const [filter, setFilter] = useState("");

    const [selectedAsset, setSelectedAsset] = useState("");

    useEffect(() => {
        if (!show) {
            setSelectedAsset("");
        }
    }, [show]);

    useEffect(() => {
        if (selectedAsset) {
            dispatch(setNewFixedAssetRecordAutomatedData({
                selectedAsset: assets.find((el) => el._id === selectedAsset),
            }));
        }
    }, [selectedAsset]);

    const toViewFixedAsset = () => {
        axios.get(`${process.env.REACT_APP_API_URL2}/fixedassets/get-asset-by-id`, {
            params: {
                company: company.id,
                id: rowData.correlatedFixedAsset,
            }
        }).then((res) => {
            if (res.data.status === "200") {
                openFixedAssetLocal(res.data.data, TABS_DATA);
            } else {
                toast.error("Το πάγιο δεν βρέθηκε.");
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την άντληση παγίου.");
        })
    }

    const toCorrelateFixedAsset = () => {
        setShow(true);
        setLoadingAssets(true);
        axios.get(`${process.env.REACT_APP_API_URL2}/fixedassets/fetch-active-assets`, {
            params: {
                company: company.id,
                includeAll: true,
            }
        }).then((res) => {
            if (res.data.status === "200") setAssets(res.data.data);
            setLoadingAssets(false);
        }).catch((err) => {
            setLoadingAssets(false);
            console.log(err);
            toast.error("Σφάλμα κατά την άντληση παγίων.");
        })
    }

    const postNewAssetRecord = async () => {
        setLoadingCorrelation(true);
        const postData = {...FIXED_ASSETS.newFixedAssetRecord, ...{company: company.id, year: String(company.year)}};
        const validationResponse = validateFixedAssetRecord(postData, company);
        if (!validationResponse.success) {
            setLoadingCorrelation(false);
            return toast.error(validationResponse.message);
        }

        try {
            const correlationResponse = await axios.post(`${process.env.REACT_APP_API_URL2}/fixedassets/correlate-sale-with-fixed-asset`, {
                company: company.id,
                selectedAsset: selectedAsset,

                correlatedSale: SALES.editSales[tabKey]._id,
                correlatedSaleLabel: getDocumentLabel(SALES.editSales[tabKey]),
                correlatedSaleRowNumber: String(rowData.no),
            }, {
                headers: {'Content-Type': 'application/json'},
            });
            if (correlationResponse.data.status !== "200") {
                setLoadingCorrelation(false);
                return toast.error(correlationResponse.data.message);
            }
        } catch (axiosError) {
            setLoadingCorrelation(false);
            return toast.error("Σφάλμα κατά την συσχέτιση παγίου με την πώληση");
        }
        dispatch(postFixedAssetRecord(postData, () => {
            toast.success("Επιτυχής συσχέτιση & εγγραφή.");
            setShow(false);
            setLoadingCorrelation(false);
        }))
    }

    const renderActionCell = (asset) => {
        if (asset.correlatedSale) {
            return <Badge bg={"info"} style={{userSelect: "none"}}>Αφορά άλλη πώληση</Badge>;
        } else {
            if (selectedAsset === asset._id) {
                return <Badge bg={"success"} style={{userSelect: "none"}}>Επιλεγμένο</Badge>
            } else {
                return <Badge bg={"dark"} style={{cursor: "pointer", userSelect: "none"}} onClick={() => setSelectedAsset(asset._id)}>Επιλογή</Badge>
            }
        }
    }

    return (
        <React.Fragment>
            {(TABS_DATA[ACTIVE_MAIN_TAB].tabType === "view-sales" && checkPermissionMasterParentStartingTree("fixedassets", permissionsData) === true) && (
                <React.Fragment>
                    {isEmpty(rowData?.correlatedFixedAsset) ? (
                        <div style={{textAlign: "center"}}>
                            <Button style={{pointerEvents: "auto", width: "100%"}}
                                    size={"sm"} variant={"primary"} backdrop={"static"} onClick={() => toCorrelateFixedAsset()}>
                                <LuPackageSearch size={18} /> Συσχέτιση & Απόσβεση παγίου
                            </Button>
                        </div>
                    ) : (
                        <div style={{textAlign: "center"}}>
                            <Button style={{pointerEvents: "auto", width: "100%"}}
                                    size={"sm"} variant={"primary"} backdrop={"static"} onClick={() => toViewFixedAsset()}>
                                <LuPackageCheck size={18} /> Προβολή παγίου
                            </Button>
                        </div>
                    )}

                    <Modal show={show} onHide={() => setShow(false)} backdrop={"static"} dialogClassName={"modal65PercentWidth"}>
                        <Modal.Header closeButton>
                            <Modal.Title>Συσχέτιση παγίου</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {show && (
                                <React.Fragment>
                                    {loadingAssets ? (
                                        <div style={{textAlign: "center"}}>Γίνεται φόρτωση παγίων παρακαλώ περιμένετε...</div>
                                    ) : (
                                        <React.Fragment>
                                            <Row>
                                                <Col md={4}>
                                                    <Input
                                                        name={"filter"}
                                                        label={"Όνομα/Κωδικός Παγίου"}
                                                        value={filter}
                                                        onChange={(e) => setFilter(e.target.value)}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row className={"mt-2"}>
                                                <Col md={12}>
                                                    {assets.length > 0 && (
                                                        <table className={"simpleClassicTable"}>
                                                            <thead>
                                                            <tr>
                                                                <th>Κωδικός Παγίου / Χειροκίνητος Κωδικός</th>
                                                                <th>Όνομα</th>
                                                                <th>Αξία κτήσης</th>
                                                                <th>Αποσβεσμένο ποσό</th>
                                                                <th>Αναπόσβεστο ποσό / Υπόλοιπο</th>
                                                                <th>Επιλογή</th>
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            {assets.filter((el) => {
                                                                if (filter) {
                                                                    const lc = String(filter).toLowerCase();
                                                                    if (String(el.name).toLowerCase().includes(lc)
                                                                        || String(el.systemCode).toLowerCase().includes(lc)
                                                                        || String(el.manualCode).toLowerCase().includes(lc)
                                                                    ) {
                                                                        return el;
                                                                    } else {
                                                                        return null;
                                                                    }
                                                                } else {
                                                                    return el;
                                                                }
                                                            }).filter(Boolean).map((asset, idx) => (
                                                                <tr key={`fasa-${idx}`}>
                                                                    <td>{asset.systemCode + (asset.manualCode ? ` / ${asset.manualCode}` : "")}</td>
                                                                    <td>{asset.name}</td>
                                                                    <td>{getGreekCurrencyFormat(asset.acquisitionCost)}</td>
                                                                    <td>{getGreekCurrencyFormat(asset.accumulatedDepreciation)}</td>
                                                                    <td>{getGreekCurrencyFormat(asset.balance)}</td>
                                                                    <td>{renderActionCell(asset)}</td>
                                                                </tr>
                                                            ))}
                                                            </tbody>
                                                        </table>
                                                    )}
                                                </Col>
                                            </Row>
                                            {selectedAsset && (
                                                <Row>
                                                    <div className={"mt-3 mb-3 border-top text-muted"}><i>Εγγραφή Απόσβεσης</i></div>
                                                    <NewFixedAssetRecord fromSale={true} defaultDate={SALES.editSales[tabKey].date} />
                                                </Row>
                                            )}
                                        </React.Fragment>
                                    )}
                                </React.Fragment>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="outline-primary" onClick={() => setShow(false)}>
                                Κλείσιμο
                            </Button>
                            <Button variant="primary" onClick={() => postNewAssetRecord()} disabled={!selectedAsset || loadingCorellation}>
                                Συσχέτιση παγίου και έκδοση απόσβεσης {loadingCorellation && <Spinner className={"ml-2"} animation={"border"} variant={"dark"}/>}
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </React.Fragment>
            )}
        </React.Fragment>
    )
}